import React from 'react'
import "./TradeBuySell.scss"
import moment from 'moment'
import { useSelector } from 'react-redux'
import { toFix } from '../../../../helpers/commonHelper'

const TradeBuySell = ({ className, orderclass, clrclass, headclass, head, tradeBook }) => {
    const selectedPair = useSelector(state => state.ats.selectedPair);
    return (
        <>
            <div className={`tradeBuysell ${className}`}>
                {head && (
                    <div className={`tradeBuysell_Row BuysellThead ${headclass}`}>
                        <div className='tradeBuysell_Col'>
                            <h6 className='text-start'>Price <span className='d-block'>{selectedPair ? `${selectedPair?.baseCurrency.toUpperCase()}` : ''}</span></h6>
                            {/* <h6 className='text-start'>Price <span className='d-block'>{selectedPair ? `(${selectedPair?.name?.split('/')[1].toUpperCase()})` : '()'}</span></h6> */}
                        </div>
                        <div className='tradeBuysell_Col'>
                            <h6 className=''>Size <span className='d-block'>{selectedPair ? `${selectedPair?.otherCurrency.toUpperCase()}` : ''}</span></h6>
                            {/* <h6 className=''>Size <span className='d-block'>{selectedPair ? `(${selectedPair?.name?.split('/')[0].toUpperCase()})` : '()'}</span></h6> */}
                        </div>
                        <div className='tradeBuysell_Col'>
                            <h6>Time</h6>
                        </div>
                    </div>
                )}
                <div className={`BuysellTdata ${orderclass}`}>
                    {tradeBook.map((item, i) => {
                        return (
                            <div key={i} className="tradeBuysell_Row">
                                <div className='tradeBuysell_Col'>
                                    <p className={`text-start ${clrclass}`}>{toFix(item.price, selectedPair?.price_decimal)}</p>
                                </div>
                                <div className='tradeBuysell_Col'>
                                    <p>{toFix(item.filled_amount, selectedPair?.quantity_decimal)}</p>
                                </div>
                                <div className='tradeBuysell_Col'>
                                    <p>{moment(item.created_at).format('HH:mm:ss')}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default TradeBuySell
